import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "91",
  height: "104",
  fill: "none",
  viewBox: "0 0 91 104"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#653434",
      d: "M44.5 8c0-4.704 3.183-8 8-8s8 3.29 8 8-3.183 8-8 8-8-3.297-8-8ZM58.974 22.756v28.61c0 12.356-6.728 20.064-19.896 20.064-9.154 0-15.974-3.717-20.178-10.96l10.184-6.873c2.427 3.716 5.417 5.294 9.154 5.294 4.86 0 7.286-2.784 7.286-8.359v-27.77h13.45v-.006Z"
    }, null, -1)
  ])))
}
export default { render: render }